import React, { useState } from "react";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { FormBox } from "./FormBox"
import { TableBox } from "./TableBox"
import { FixedBottom } from "./FixedBottom"

export const BmsBusRoDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    return (
        <>
            <FormBox  {...detailsInfo} />
            <TableBox {...detailsInfo} />
            <FixedBottom {...detailsInfo} />
        </>
    )
}